import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_PROJECT_LIST = gql`
  query projectList($filter: ProjectFilter) {
    projectList(filter: $filter) {
      total
      projectLimit
      activeProjectCount
      data {
        id
        name
        accessLevel
        uniqueCode
        clientName
        isActive
        projectUsers {
          id
          userId
          user {
            id
            name
            isDisabled
          }
          roles
        }
        creator {
          id
          name
        }
        timeZone
        updatedAt
      }
    }
  }
`;

export const GET_PROJECT_DROPDOWN_LIST = gql`
  query projectDropdownList($filter: ProjectFilter) {
    projectDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const GET_DASHBOARD_PROJECT_DROPDOWN_LIST = gql`
  query DashboardProjectDropdownList($filter: ProjectFilter) {
    dashboardProjectDropdownList(filter: $filter) {
      activeProjectCount
      data {
        id
        name
      }
      total
    }
  }
`;

export const ASSET_PROJECT_DROPDOWN_LIST = gql`
  query assetProjectDropdownList($filter: ProjectFilter) {
    assetProjectDropdownList(filter: $filter) {
      total
      data {
        id
        name
        uniqueCode
      }
    }
  }
`;

export const ASSET_EQC_TYPE_DROPDOWN_LIST = gql`
  query assetProjectEqcTypeDropdownList($filter: ProjectEqcTypeFilter!) {
    assetProjectEqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const ASSET_EQC_TYPE_STAGE_DROPDOWN_LIST = gql`
  query assetProjectEqcTypeStageDropdownList(
    $filter: ProjectEqcTypeStageFilter!
  ) {
    assetProjectEqcTypeStageDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const ASSET_EQC_TYPE_STAGE_ITEM_DROPDOWN_LIST = gql`
  query assetProjectEqcTypeStageItemDropdownList(
    $filter: ProjectEqcTypeStageItemFilter!
  ) {
    assetProjectEqcTypeStageItemDropdownList(filter: $filter) {
      total
      data {
        id
        title
      }
    }
  }
`;

export const GET_SINGLE_PROJECT = gql`
  query getProject($id: ID!) {
    getProject(id: $id) {
      id
      name
      uniqueCode
      clientName
      isRfiRequestSent
      accessLevel
      projectAdminId
      isReportConfigRequestSent
      description
      longitude
      latitude
      isRfiActive
      radius
      permissions
      access
      timeZone
      nomenclatureCount
      isNomenclatureRequestSent
      isNomenclaturePublished
      isActive
      logo
      projectRFIs {
        id
        status
      }
      projectUsers {
        id
        userId
        roles
        access
      }
    }
  }
`;

export const GET_ALL_USERS = gql`
  query projectUserDropdownList($filter: ProjectUserFilter!) {
    projectUserDropdownList(filter: $filter) {
      total
      data {
        id
        name
        roles
        email
      }
    }
  }
`;

export const GET_ONBOARDED_PROJECT_USERS = gql`
  query onboardProjectUserList($filter: ProjectUserFilter!) {
    onboardProjectUserList(filter: $filter) {
      total
      data {
        id
        user {
          id
          name
          roles
        }
        roles
      }
    }
  }
`;

export const GET_PROJECT_USERS_FOR_EQC_TYPES = gql`
  query projectEqcTypeUserDropdownList($filter: ProjectUserFilter!) {
    projectEqcTypeUserDropdownList(filter: $filter) {
      total
      projectAdminContains
      data {
        id
        user {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_AGENCIES = gql`
  query agencyDropdownList($filter: ProjectAgencyFilter) {
    agencyDropdownList(filter: $filter) {
      total
      data {
        id
        name
        users {
          id
          name
        }
      }
    }
  }
`;

export const GET_ONBOARDED_PROJECT_AGENCY_LIST = gql`
  query onboardProjectAgencyList($filter: ProjectAgencyFilter!) {
    onboardProjectAgencyList(filter: $filter) {
      total
      data {
        id
        agencyId
        agency {
          id
          name
          type
          users {
            id
            name
          }
        }
        projectAgencyContacts {
          contact {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_AGENCY_LIST = gql`
  query projectAgencyList($filter: ProjectAgencyFilter!) {
    projectAgencyList(filter: $filter) {
      total
      data {
        id
        projectId
        agencyId
        agency {
          id
          name
          type
          contacts {
            id
            name
            phoneNo
            email
          }
        }
        projectAgencyContacts {
          user {
            id
            name
            phoneNo
            email
          }
        }
        projectAgencyEqcs {
          id
          name
        }
      }
    }
  }
`;
export const GET_UNASSIGN_AGENCY_LIST = gql`
  query unassignAgencyUserList($filter: ProjectAgencyFilter!) {
    unassignAgencyUserList(filter: $filter) {
      total
      data {
        id
        name
        phoneNo
        email
        isActive
        roles
      }
    }
  }
`;
export const GET_UNASSIGN_AGENCY_LIST_COUNT = gql`
  query unassignAgencyUserList($filter: ProjectAgencyFilter!) {
    unassignAgencyUserList(filter: $filter) {
      total
    }
  }
`;

export const GET_UNASSIGN_CONTACT_LIST_COUNT = gql`
  query unassignedUserList($filter: UserFilter!) {
    unassignedUserList(filter: $filter) {
      total
    }
  }
`;

export const GET_UNASSIGN_CONTACT_LIST = gql`
  query unassignedUserList($filter: UserFilter) {
    unassignedUserList(filter: $filter) {
      total
      data {
        user {
          id
          name
          phoneNo
        }
        project {
          id
          name
        }
      }
    }
  }
`;

export const GET_PROJECT_AGENCY_FOR_EQC_TYPES = gql`
  query projectEqcTypeAgencyDropdownList($filter: ProjectAgencyFilter!) {
    projectEqcTypeAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        agency {
          id
          name
        }
      }
    }
  }
`;

export const GET_ALL_EQC_TYPE = gql`
  query projectEqcTypeDropdownList($filter: ProjectEqcTypeFilter!) {
    projectEqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;

export const GET_PROJECT_AGENCY_DROPDOWN_LIST = gql`
  query agencyDropdownList($filter: ProjectAgencyFilter) {
    agencyDropdownList(filter: $filter) {
      data {
        id
        name
        type
      }
      total
    }
  }
`;

export const ASSIGN_CONTACT_AGENCY_DROPDOWN_LIST = gql`
  query assignContactAgencyDropdownList($filter: ProjectAgencyFilter) {
    assignContactAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        name
        projectAgencies {
          id
        }
      }
    }
  }
`;

export const GET_PROJECT_USER_EQC_TYPES_LIST = gql`
  query projectUserEqcTypeDropdownList($filter: ProjectEqcTypeFilter!) {
    projectUserEqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;
export const GET_PROJECT_AGENCY_EQC_TYPES_LIST = gql`
  query projectAgencyEqcTypeDropdownList($filter: ProjectEqcTypeFilter!) {
    projectAgencyEqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;
export const GET_PROJECT_EQCTYPES_LIST_MIN = gql`
  query projectEqcTypeList($filter: ProjectEqcTypeFilter!) {
    projectEqcTypeList(filter: $filter) {
      total
      data {
        id
        name
        projectId
        status
      }
    }
  }
`;

export const GET_PROJECT_EQC_TYPES_LIST = gql`
  query projectEqcTypeList($filter: ProjectEqcTypeFilter!) {
    projectEqcTypeList(filter: $filter) {
      total
      data {
        id
        name
        uom
        iso
        status
        eqcTypeId
        createdBy
        isRfiActive
        projectEqcTypeStages {
          id
          name
          needApproval
          projectEqcTypeStageApprovals {
            id
            levelName
            levelNumber
            internalApproverId
            externalUserApproverId
            internalApproverName
            externalUserApproverName
          }
        }
        projectUserEqcTypes {
          projectUser {
            user {
              id
              name
            }
          }
        }
        projectRFIUsers {
          projectUser {
            user {
              id
              name
            }
          }
        }
        projectAgencyEqcTypes {
          projectAgency {
            agency {
              id
              name
            }
          }
        }
      }
    }
  }
`;
export const GET_PROJECT_USER_LIST = gql`
  query projectUserList($filter: ProjectUserFilter!) {
    projectUserList(filter: $filter) {
      total
      licensedUserCount
      complimentaryUserCount
      data {
        id
        projectId
        userId
        roles
        webAccess
        accessLevel
        access
        permissions
        assignedAsApprover
        deactivateAsApprover
        user {
          id
          name
          roles
          email
          phoneNo
        }
        linkedAgencies {
          id
          name
        }
        projectUserEqcTypes {
          id
          name
        }
        projectUserRFIEqcTypes {
          id
          name
        }
      }
    }
  }
`;

export const GET_PROJECT_EQC_TYPE_DROPDOWN_LIST = gql`
  query projectEqcTypeDropdownList($filter: ProjectEqcTypeFilter!) {
    projectEqcTypeDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;
export const GET_PROJECT_USER_DROPDOWN_LIST = gql`
  query projectUserDropdownList($filter: ProjectUserFilter!) {
    projectUserDropdownList(filter: $filter) {
      total
      data {
        id
        name
        roles
        email
        isLocal
      }
    }
  }
`;

export const PROJECT_USER_AGENCY_DROPDOWN_LIST = gql`
  query ProjectUserAgencyDropdownList($filter: ProjectAgencyFilter!) {
    projectUserAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        name
        type
        tenantId
        createdAt
        updatedAt
      }
    }
  }
`;

export const PROJECT_REPLICATE_USER_LIST = gql`
  query ProjectReplicateUserList($filter: ProjectReplicateUserListFilter!) {
    projectReplicateUserList(filter: $filter) {
      total
      data {
        id
        projectUser {
          id
          user {
            name
          }
        }
        projectAgency {
          id
          agency {
            name
          }
        }
      }
    }
  }
`;

export const GET_AGENCY_CONTACTS_DROPDOWN_LIST = gql`
  query projectAgencyUserDropdownList($filter: ProjectAgencyFilter) {
    projectAgencyUserDropdownList(filter: $filter) {
      total
      data {
        id
        name
      }
    }
  }
`;
export const GET_PROJECT_EQC_LIST = gql`
  query eqcList($filter: EqcFilter) {
    eqcList(filter: $filter) {
      total
      data {
        id
        eqcName
        projectEqcTypeName
        status
        workStatus
        eqcStageIndex
        eqcStageCount
        doneAt
        isAudited
        createdAt
        creator {
          id
          name
        }
        modifier {
          id
          name
        }
        eqcStageHistories {
          id
          name
          status
          eqcStageId
          levelName
          levelNumber
          isOverdue
          isRfiStage
          inspectorReminderDate
          projectEqcTypeStageApprovals {
            id
            internalApproverId
            externalUserApproverId
            levelName
            levelNumber
            internalApproverName
            externalUserApproverName
          }
          eqcApprovalLogs {
            id
            internalApproverId
            externalUserApproverId
            approvalStatus
            levelName
            levelNumber
            approvedAt
            redoAt
            internalApproverName
            externalUserApproverName
          }
        }
        eqcStages {
          id
          name
          internalApproverName
          externalUserApproverName
          status
          eqcStageApprovals {
            id
            levelName
            levelNumber
            internalApproverId
            externalUserApproverId
            internalApproverName
            externalUserApproverName
          }
        }
        updatedAt
      }
    }
  }
`;

export const GET_PROJECT_REGISTER_EQC_LIST = gql`
  query RegisterEqcList($filter: EqcFilter) {
    registerEqcList(filter: $filter) {
      data {
        eqcName
        id
      }
    }
  }
`;

export const GET_PROJECT_EQC = gql`
  query getEqc($id: ID!) {
    getEqc(id: $id) {
      id
      eqcName
      projectEqcTypeName
      status
      workStatus
      doneAt
      projectEqcTypeName
      projectEqcTypeId
      uom
      isAudited
      eqcCompletedAt
      eqcStartedAt
      eqcSyncedAt
      eqcRenameLogs {
        id
        newName
        oldName
        action {
          id
          name
        }
        updatedAt
      }
      creator {
        id
        name
      }
      modifier {
        id
        name
      }
      eqcStageHistories {
        id
        name
        status
        eqcStageId
        eqcStageStartedAt
        eqcStageCompletedAt
        eqcStagePausedAt
        eqcStageRestartedAt
        eqcApprovalLogs {
          id
          approvalDetails
          updatedAt
        }
      }
      eqcStages {
        id
        name
        internalApproverName
        externalUserApproverName
        order
        status
        drawingTitleImg
        drawingImg
        witnessesImg
        witnessesId
        latitude
        projectEqcTypeStageId
        longitude
        updatedAt
        eqcStageStartedAt
        eqcStageCompletedAt
        eqcStagePausedAt
        eqcStageRestartedAt
        eqcStageSynceStartedAt
        eqcStageSynceCompletedAt
        actions {
          id
          name
        }
        eqcStageItems {
          id
          title
          description
          type
          options
          photo
          remark
          photos
          remarkAudios
          remarks
          qcOption
          generalRemark
          isFailedImmediately
          generalRemarkImages
          order
          qcStatus
        }
      }
      updatedAt
    }
  }
`;

export const GET_EQC_STAGE_HISTORY_LIST = gql`
  query eqcStageHistoryListByProjectEqc($filter: EqcStageHistoryInfoInput!) {
    eqcStageHistoryListByProjectEqc(filter: $filter) {
      id
      name
      status
      drawingTitleImg
      drawingImg
      witnessesImg
      drawingPDF
      witnessesId
      latitude
      longitude
      updatedAt
      actionAt
      itemHistory
      skipRemark
      levelName
      levelNumber
      isRfiStage
      byPassRemark
      eqcPauseLogs {
        id
      }
      skipImages
      skipAudios
      byPassedImages
      byPassedAudios
      eqcStageCompletedAt
      eqcStageStartedAt
      eqcStageSynceStartedAt
      eqcStageSynceCompletedAt
      inspectorReminderDate
      isRfiStage
      projectAgency {
        agency {
          name
          id
        }
      }
      eqcApprovalLogs {
        id
        approvalDetails
        updatedAt
      }
      action {
        id
        name
      }
    }
  }
`;

export const GET_EQC_STAGE_HISTORY = gql`
  query getWebStageHistory($id: ID!) {
    getWebStageHistory(id: $id) {
      id
      name
      status
      drawingTitleImg
      drawingImg
      witnessesImg
      witnessesId
      latitude
      longitude
      updatedAt
      actionAt
      itemHistory
      stageApprovals {
        id
        approvalDetails
        updatedAt
      }
      action {
        id
        name
      }
    }
  }
`;
export const GET_PROJECT_INSTRUCTION_LIST = gql`
  query instructionList($filter: InstructionFilter!) {
    instructionList(filter: $filter) {
      total
      data {
        id
        name
        tags
        description
        type
        status
        reminderDate
        createdAt
        descriptionPhoto
        descriptionAudio
        closingRemark
        closingAudio
        closingPhoto
        closedOn
        isOverdue
        analysis {
          labourCost
          machineryCost
          materialCost
          otherCost
          totalCost
        }
        users {
          name
          phoneNo
        }
        projectAgency {
          agency {
            name
            type
          }
        }
        creator {
          name
        }
        modifier {
          id
          name
        }
        responderUser {
          id
          name
        }
      }
    }
  }
`;

export const GET_PROJECT_INSTRUCTION = gql`
  query getInstruction($id: ID!) {
    getInstruction(id: $id) {
      id
      name
      description
      tags
      type
      analysis {
        id
        instructionId
        rootCauseAnalysis
        correction
        correctiveAction
        labourCost
        materialCost
        machineryCost
        otherCost
        totalCost
        tenantId
        createdBy
        modifiedBy
        createdAt
        updatedAt
        creator {
          name
        }
        modifier {
          name
        }
      }
      projectAgency {
        agency {
          name
          type
        }
      }
      status
      reminderDate
      creator {
        name
      }
      modifier {
        id
        name
      }
      closer {
        id
        name
      }
      responderUser {
        id
        name
      }
      tenant {
        id
        organizationName
      }
      instructionAgencyContacts {
        user {
          name
          phoneNo
        }
      }
      instructionIssueHistories {
        id
        status
        photos
        audios
        projectId
        remark
        revision
        latitude
        longitude
        projectAgencyId
        createdAt
        rejector {
          id
          name
        }
        responderUser {
          id
          name
        }
        creator {
          id
          name
          email
        }
      }
      instructionHistory {
        id
        modifier {
          id
          name
        }
        createdAt
        afterJson
        beforeJson
      }
      instructionRenameLogs {
        id
        newName
        oldName
        user {
          id
          name
        }
        updatedAt
      }
      createdAt
      descriptionPhoto
      descriptionAudio
      closingRemark
      closingAudio
      closingPhoto
      closedOn
      respondedOn
    }
  }
`;

export const GET_PROJECT_AUDITOR_COMMENTS = gql`
  query auditorCommentList($filter: AuditorCommentFilter!) {
    auditorCommentList(filter: $filter) {
      total
      data {
        id
        comment
        auditor {
          id
          name
        }
        createdAt
      }
    }
  }
`;

export const EQC_PAUSE_LOG_LIST_BY_HISTORY = gql`
  query eqcPauseLogListByHistory($filter: EqcPauseLogInput!) {
    eqcPauseLogListByHistory(filter: $filter) {
      total
      data {
        id
        remark
        pausedAt
        restartedAt
        tenantId
      }
    }
  }
`;

export const GET_PROJECT_EQC_TYPE = gql`
  query getProjectEqcType($id: ID!) {
    getProjectEqcType(id: $id) {
      id
      name
      uom
      iso
      status
      isAudited
      activityLogCount
      projectEqcType {
        id
        status
      }
      projectEqcTypeStageCount
      projectUserEqcTypes {
        id
        projectUser {
          id
          user {
            id
          }
        }
      }
      projectAgencyEqcTypes {
        id
        projectAgency {
          id
        }
      }
      project {
        id
        name
        isActive
        permissions
        isRfiRequestSent
        projectRFIs {
          id
          status
        }
        projectUsers {
          id
          userId
          roles
        }
      }
      creator {
        id
        name
      }
    }
  }
`;

export const GET_PROJECT_STAGE_LIST = gql`
  query projectEqcTypeStageList($filter: ProjectEqcTypeStageFilter!) {
    projectEqcTypeStageList(filter: $filter) {
      total
      activeStageCount
      rfiStageCount
      data {
        id
        name
        order
        drawing
        witness
        isReRfiRequired
        needApproval
        stageConfiguration
        itemOrderType
        isActive
        type
        isRfiActive
        rfiStage {
          id
          name
          order
          drawing
          witness
          isReRfiRequired
          needApproval
          stageConfiguration
          itemOrderType
          isActive
          type
          stageRfiId
          projectEqcTypeStageApprovals {
            id
            internalApproverId
            externalUserApproverId
            userAgencyId
            levelName
            levelNumber
            externalUserApprover {
              id
              name
            }
            internalApprover {
              id
              user {
                id
                name
              }
            }
          }
        }
        stageRfiId
        projectEqcTypeStageApprovals {
          id
          approvalType
          internalApproverId
          externalUserApproverId
          userAgencyId
          levelName
          levelNumber
          externalUserApprover {
            id
            name
          }
          internalApprover {
            id
            user {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_PROJECT_STAGE_ITEM_LIST = gql`
  query projectEqcTypeStageItemList($filter: ProjectEqcTypeStageItemFilter!) {
    projectEqcTypeStageItemList(filter: $filter) {
      total
      totalActiveCount
      newItemCount
      data {
        id
        title
        type
        order
        options
        photo
        remark
        description
        isActive
        previousHistory
        projectEqcTypeStageItemId
      }
    }
  }
`;

export const GET_INTERNAL_USERS_LIST = gql`
  query internalApproverDropdownList($filter: ProjectUserFilter!) {
    internalApproverDropdownList(filter: $filter) {
      total
      data {
        id
        user {
          id
          name
        }
      }
    }
  }
`;

export const GET_EXTERNAL_USERS_LIST = gql`
  query externalUserApproverDropdownList($filter: ProjectAgencyFilter!) {
    externalUserApproverDropdownList(filter: $filter) {
      total
      data {
        id
        name
        agency {
          id
          name
        }
      }
    }
  }
`;

export const INTERNAL_APPROVER_TEAM_DROPDOWN_LIST = gql`
  query InternalApproverTeamDropdownList($filter: ProjectUserFilter!) {
    internalApproverTeamDropdownList(filter: $filter) {
      total
      assignedApproverIds
      data {
        agencyId
        agencyName
        userCount
        users {
          id
          userId
          roles
          user {
            id
            name
          }
        }
      }
    }
  }
`;

export const EXTERNAL_APPROVER_TEAM_DROPDOWN_LIST = gql`
  query ExternalApproverTeamDropdownList($filter: ProjectAgencyFilter!) {
    externalApproverTeamDropdownList(filter: $filter) {
      total
      assignedUserAgencyIds
      data {
        agencyId
        agencyName
        userCount
        users {
          id
          name
          email
          agency {
            id
            name
            type
          }
        }
      }
    }
  }
`;

export const GET_INSTRUCTION_RECOMMENDATION_LIST = gql`
  query recommendationList($instructionId: ID!) {
    recommendationList(instructionId: $instructionId) {
      total
      data {
        id
        beforeJson
        afterJson
        modifiedBy
        modifier {
          id
          name
        }
        updatedAt
      }
    }
  }
`;

export const GET_PROJECT_EQC_TYPE_COUNT = gql`
  query projectEqcTypeList($filter: ProjectEqcTypeFilter!) {
    projectEqcTypeList(filter: $filter) {
      data {
        id
      }
    }
  }
`;

export const PROJECT_AGENCY_DROPDOWN = gql`
  query projectAgencyDropdownList($filter: ProjectAgencyFilter!) {
    projectAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        agency {
          id
          name
        }
      }
    }
  }
`;

export const INSTRUCTION_TAG_LIST = gql`
  query instructionTagList($filter: InstructionFilter!) {
    instructionTagList(filter: $filter) {
      total
      data
    }
  }
`;
export const PROJECT_USER_DROPDOWN = gql`
  query projectUserDropdownList($filter: ProjectUserFilter!) {
    projectUserDropdownList(filter: $filter) {
      total
      data {
        id
        name
        email
      }
    }
  }
`;

export const GET_PROJECT_EQC_TYPE_VERSION_LOGS = gql`
  query getProjectEqcTypeVersionLogs($id: ID!) {
    getProjectEqcTypeVersionLogs(id: $id) {
      data
    }
  }
`;

export const GET_PROJECT_RFI_VERSION_LOGS = gql`
  query getProjectRFIVersionLogs($projectId: ID!) {
    getProjectRFIVersionLogs(projectId: $projectId) {
      data
    }
  }
`;

export const TARGET_ACTUAL_METRIC_LIST = gql`
  query targetActualMetricList($filter: TargetActualMetricFilter!) {
    targetActualMetricList(filter: $filter) {
      total
      data {
        id
        startDate
        endDate
        target
        eqcCompletedCount
      }
      nextTargetAvailable
      previousTargetAvailable
    }
  }
`;

export const INSTRUCTION_OTHER_TYPE_LIST = gql`
  query instructionOtherTypeDropdownList($filter: InstructionFilter!) {
    instructionOtherTypeDropdownList(filter: $filter) {
      total
      data
    }
  }
`;

export const INSTRUCTION_ORGANIZATION_TYPE_LIST = gql`
  query instructionOrganizationTypeList(
    $data: InstructionOrganizationTypeListInput
  ) {
    instructionOrganizationTypeList(data: $data) {
      id
      name
      level
      parentLevelId
      order
      isActive
      tenantId
      createdBy
      modifiedBy
      createdAt
      updatedAt
    }
  }
`;

export const PROJECT_NOMENCLATURE_LIST = gql`
  query projectNomenclatureList($filter: NomenclatureFilter!) {
    projectNomenclatureList(filter: $filter)
  }
`;

export const PROJECT_REGISTER_NOMENCLATURE_LIST = gql`
  query Query($filter: NomenclatureFilter!) {
    projectRegisterNomenclatureList(filter: $filter)
  }
`;

export const REQUEST_NOMENCLATURE_FEATURE = gql`
  query requestProjectNomenclatureFeature($projectId: ID!) {
    requestProjectNomenclatureFeature(projectId: $projectId) {
      status
      message
      systemAdminList {
        name
        phoneNo
      }
    }
  }
`;

export const PROJECT_RFI_POINTS_LIST = gql`
  query projectRFIPointList($filter: ProjectRFIPointFilter!) {
    projectRFIPointList(filter: $filter) {
      total
      data {
        id
        title
        description
        type
        options
        photo
        remark
        order
        isActive
        projectId
        projectRfiId
        createdBy
        modifiedBy
        tenantId
        isNewPoint
      }
    }
  }
`;

export const GET_PROJECT_RFI = gql`
  query getProjectRFI($projectRFIId: ID!) {
    getProjectRFI(projectRFIId: $projectRFIId) {
      id
      status
      version
      projectId
      projectRfiId
      createdBy
      modifiedBy
      witness
      drawing
      isReRfiRequired
      tenantId
      publishedOn
      publishedBy
      projectRfi {
        id
        status
      }
      activityLogCount
      project {
        id
        name
        isActive
        isRfiActive
        isRfiRequestSent
      }
    }
  }
`;
export const GET_PROJECT_REPORT_CONFIG = gql`
  query getProjectReportConfig($projectId: ID!) {
    getProjectReportConfig(projectId: $projectId) {
      id
      organizationLogoRequired
      organizationLogoSize
      organizationNameRequired
      statusRequired
      photoSectionRequired
      photoSize
      reportTitleRequired
      reportTitle
      projectPhotos
      createdAt
      updatedAt
    }
  }
`;

export const REGISTER_LIST = gql`
  query registerList($projectId: ID!, $filter: RegisterFilter) {
    registerList(projectId: $projectId, filter: $filter) {
      total
      data {
        id
        name
        numberOfLogs
        numberOfEntries
        status
        createdAt
      }
    }
  }
`;

export const GET_REGISTER = gql`
  query getRegister($getRegisterId: ID!) {
    getRegister(id: $getRegisterId) {
      id
      name
      status
      needApproval
      type
      createdAt
      parentRegisterId
      updatedAt
      project {
        timeZone
      }
      registerDetails {
        id
        name
        type
        sequence
        options
        createdAt
        isRequired
        deletedAt
        calculationResultType
        calculationFieldType
      }
      registerFormFields {
        id
        name
        type
        options
        sequence
        createdAt
        isRequired
        calculationResultType
        deletedAt
      }
      approvers {
        id
        levelName
        levelNumber
        internalApproverId
        internalUserApproverId
        externalUserApproverId
        internalApprover {
          id
          user {
            id
            name
          }
        }
        internalUserApprover {
          id
          name
        }
        externalUserApprover {
          id
          name
        }
      }
    }
  }
`;

export const GET_REGISTER_LOGS = gql`
  query registerLogDetailEntryByRegisterList(
    $registerId: ID!
    $filter: RegisterLogDetailEntryRegisterFilter!
  ) {
    registerLogDetailEntryByRegisterList(
      registerId: $registerId
      filter: $filter
    ) {
      total
      data
    }
  }
`;

export const GET_REGISTER_ENTRIES = gql`
  query registerLogEntryByRegisterList(
    $registerId: ID!
    $filter: RegisterFilter!
  ) {
    registerLogEntryByRegisterList(registerId: $registerId, filter: $filter) {
      data
      total
    }
  }
`;

export const GET_REGISTER_LOG_DETAILS_ENTRY = gql`
  query registerLogDetailEntryList(
    $registerLogId: ID!
    $filter: RegisterFilter
  ) {
    registerLogDetailEntryList(registerLogId: $registerLogId, filter: $filter) {
      total
      registerLogStatus
      data {
        createdAt
        deletedAt
        id
        isRequired
        name
        options
        sequence
        registerLogDetailEntries {
          createdAt
          id
          registerDetailId
          updatedAt
          value
          comments {
            commentText
            assetUrls
            __typename
            commenter {
              name
            }
            createdAt
            approvalLevel
            approvalLevelName
            registerLogStatus
          }
          refIds
        }
        type
        updatedAt
      }
    }
  }
`;

export const GET_REGISTER_LOG_HISTORIES = gql`
  query GetRegisterLogHistories($registerLogId: ID!) {
    getRegisterLogHistories(registerLogId: $registerLogId) {
      total
      registerLog {
        id
        status
        currentApprovalLevel
        currentApprovalName
        isModifiedAfterRedo
        needApproval
        creator {
          name
        }
      }
      registerId
      data {
        id
        approvalStatus
        levelName
        levelNumber
        isLatest
        createdAt
        actor {
          name
        }
        comments {
          commentText
          assetUrls
        }
      }
    }
  }
`;

export const GET_REGISTER_LOG_FORM_FIELDS_ENTRY_LIST = gql`
  query registerLogFormFieldEntryList(
    $registerLogId: ID!
    $filter: RegisterFilter
  ) {
    registerLogFormFieldEntryList(
      registerLogId: $registerLogId
      filter: $filter
    ) {
      total
      data {
        createdAt
        id
        registerFormFieldId
        registerLogId
        responses
        updatedAt
        comments {
          commentText
          assetUrls
          __typename
          commenter {
            name
          }
          createdAt
          approvalLevel
          approvalLevelName
          registerLogStatus
        }
      }
    }
  }
`;

export const GET_REGISTER_LOG_DROPDOWN_LIST = gql`
  query registerLogDetailDistinctValues(
    $registerId: ID!
    $fieldId: ID!
    $filter: DistinctValuesFilter
  ) {
    registerLogDetailDistinctValues(
      registerId: $registerId
      fieldId: $fieldId
      filter: $filter
    ) {
      fieldId
      fieldName
      values {
        value
        label
        count
      }
      total
      __typename
    }
  }
`;

export const GET_REGISTER_ENTRIES_DROPDOWN_LIST = gql`
  query RegisterFormFieldDistinctValues(
    $registerId: ID!
    $fieldId: ID!
    $filter: DistinctValuesFilter
  ) {
    registerFormFieldDistinctValues(
      registerId: $registerId
      fieldId: $fieldId
      filter: $filter
    ) {
      fieldId
      fieldName
      values {
        value
        count
      }
      total
    }
  }
`;

export const REGISTER_LOGS_EXIST_BY_REGISTER = gql`
  query RegisterLogExistByRegister($registerId: ID!) {
    registerLogExistByRegister(registerId: $registerId) {
      registerLogExistByRegister
    }
  }
`;

export const MY_PROJECT_AGENCY_DROPDOWN_LIST = gql`
  query MyProjectAgencyDropdownList($filter: ProjectAgencyFilter!) {
    myProjectAgencyDropdownList(filter: $filter) {
      total
      data {
        id
        agency {
          name
        }
      }
    }
  }
`;

export const REGISTER_STATS = gql`
  query registerStats(
    $data: RegisterStatsInput!
    $filter: RegisterStatsFilter
  ) {
    registerStats(data: $data, filter: $filter) {
      registerId
      fieldStats {
        id
        operations {
          operation
          result
        }
      }
    }
  }
`;

export const REGISTER_INTERNAL_APPROVER_DROPDOWN_LIST = gql`
  query registerInternalApproverDropdownList($filter: RegisterApproverFilter!) {
    registerInternalApproverDropdownList(filter: $filter) {
      total
      data {
        id
        user {
          id
          name
        }
      }
    }
  }
`;

export const REGISTER_EXTERNAL_USER_APPROVER_DROPDOWN_LIST = gql`
  query registerExternalUserApproverDropdownList(
    $filter: RegisterApproverFilter!
  ) {
    registerExternalUserApproverDropdownList(filter: $filter) {
      total
      data {
        id
        name
        agency {
          id
          name
        }
      }
    }
  }
`;

export const REGISTER_APPROVERS_LIST = gql`
  query registerApproversList($registerId: ID!) {
    registerApproversList(registerId: $registerId) {
      total
      data {
        id
        levelName
        levelNumber
        internalApproverId
        internalUserApproverId
        externalUserApproverId
        internalApprover {
          id
          user {
            id
            name
          }
        }
        internalUserApprover {
          id
          name
        }
        externalUserApprover {
          id
          name
        }
      }
    }
  }
`;

export const GET_AFFECTED_LOGS_COUNT = gql`
  query getAffectedLogsCount($registerId: ID!) {
    getAffectedLogsCount(registerId: $registerId) {
      count
    }
  }
`;

export const GET_BULK_PROJECT_EQC_TYPE_STAGE_ITEMS_JOB_STATUS = gql`
  query GetBulkProjectEqcTypeStageItemsJobStatus($jobId: String!) {
    getBulkProjectEqcTypeStageItemsJobStatus(jobId: $jobId) {
      jobId
      state
      message
      result {
        addedCount
        skippedCount
        stageName
        updatedCount
        deletedCount
      }
      failedReason
    }
  }
`;

export const GET_BULK_PROJECT_STAGE_JOB_STATUS = gql`
  query GetBulkProjectStageJobStatus($jobId: String!) {
    getBulkProjectStageJobStatus(jobId: $jobId) {
      jobId
      state
      message
      result
      failedReason
    }
  }
`;

export const GET_STAGE_LEVEL_WISE_USERS = gql`
  query stageLevelWiseUsers($filter: StageLevelWiseUsersFilter!) {
    stageLevelWiseUsers(filter: $filter) {
      total
      data {
        id
        name
        order
        isActive
        levels {
          levelNumber
          levelName
          approvalType
          internalUsers {
            id
            name
            email
          }
          externalUsers {
            id
            name
            email
          }
        }
        isRfiActive
        rfiStageId
        rfiLevels {
          levelNumber
          levelName
          approvalType
          internalUsers {
            id
            name
            email
          }
          externalUsers {
            id
            name
            email
          }
        }
      }
    }
  }
`;
